export const getElementArrayByTagName = name =>
    Array.prototype.slice.call(document.getElementsByTagName(name));

export const pauseAllMediaTags = () => {
    getElementArrayByTagName('video').forEach(element => element.pause());
    getElementArrayByTagName('audio').forEach(element => element.pause());
};
